import seoSource from "../seo.json";

function normalizePath(pathname) {
  const path = String(pathname || "/").split("?")[0].split("#")[0];
  if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
  return path || "/";
}

function setTag(key, attr, value) {
  if (typeof document === "undefined" || value == null) return;
  const el = document.head.querySelector(`[data-seo="${key}"]`);
  if (el) el.setAttribute(attr, value);
}

// `raw` is the JSON text (production bundle) or the already-parsed object
// (Jest). Either way a bad value becomes null instead of throwing.
export function readSeoConfig(raw) {
  try {
    const config = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!config || typeof config !== "object" || Array.isArray(config)) return null;
    const pages =
      config.pages && typeof config.pages === "object" && !Array.isArray(config.pages)
        ? config.pages
        : {};
    const fallback =
      config.default && typeof config.default === "object" && !Array.isArray(config.default)
        ? config.default
        : null;
    return {
      origin: typeof config.origin === "string" ? config.origin : "",
      ogImagePath: typeof config.ogImagePath === "string" ? config.ogImagePath : "",
      fallback,
      pages,
    };
  } catch {
    return null;
  }
}

const seo = readSeoConfig(seoSource);

export function applyPageMeta(pathname, config) {
  try {
    const resolved = config === undefined ? seo : readSeoConfig(config);
    if (!resolved || typeof document === "undefined") return;
    const path = normalizePath(pathname);
    const page = Object.prototype.hasOwnProperty.call(resolved.pages, path)
      ? resolved.pages[path]
      : undefined;
    const pageFields = page && typeof page === "object" ? page : null;
    const fields = pageFields || resolved.fallback;
    if (!fields || typeof fields.title !== "string") return;
    const description = typeof fields.description === "string" ? fields.description : "";
    const canonical = resolved.origin + (pageFields ? path : "/");
    const image = resolved.origin + resolved.ogImagePath;
    document.title = fields.title;
    setTag("description", "content", description);
    setTag("robots", "content", pageFields && pageFields.index ? "index,follow" : "noindex,nofollow");
    setTag("canonical", "href", canonical);
    setTag("og:title", "content", fields.title);
    setTag("og:description", "content", description);
    setTag("og:url", "content", canonical);
    setTag("og:image", "content", image);
    setTag("twitter:title", "content", fields.title);
    setTag("twitter:description", "content", description);
    setTag("twitter:image", "content", image);
  } catch {
    // A missing or malformed SEO config must not blank the app.
  }
}
